import { Grid } from "@mui/material";

import {
  ButtonFooter,
  ComponentHeader,
  FloatingEditActionButtons,
  PageHeader,
  Paper,
  TextField,
} from "../../../components";

export default function FormOne({ editState, setEditState, formikProps }) {
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <PageHeader
          pageName={"Group Details"}
          pageHeader={"Add group Details"}
        />
      </Grid>

      <Grid size={12}>
        <Paper gridSpacing={4}>
          <Grid size={12}>
            <ComponentHeader title={"Group Details"} />
          </Grid>

          <Grid size={6}>
            <TextField
              required
              name="categoryName"
              placeholder="Group Name"
              label="Group Name"
              formikProps={formikProps}
              disabled={formikProps.values.id}
            />
          </Grid>

          <Grid size={6}>
            <TextField
              required
              name="categoryTitle"
              placeholder="Group Title"
              label="Group Title"
              formikProps={formikProps}
              disabled={!editState}
            />
          </Grid>

          <FloatingEditActionButtons
            ID={formikProps.values.brandID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Paper>

        {editState && (
          <Grid size={12}>
            <ButtonFooter
              editState={editState}
              setEditState={setEditState}
              ID={formikProps.values.id}
              formikProps={formikProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
